export const colors = {
  light: {
    background: '#FFFFFF',
    text: '#000000',
    textSecondary: '#FFFFFF',
    border: 'rgba(0,0,0,0.12)',
    todoBackground: 'rgba(248, 248, 248, 0.98)',
    toggleBackground: '#E0E0E0',
    toggleHandle: '#FFFFFF',
  },
  dark: {
    background: '#000000',
    text: '#FFFFFF',
    textSecondary: 'rgba(255, 255, 255, 0.7)',
    border: '#FFFFFF',
    todoBackground: 'rgba(40, 40, 40, 0.9)',
    toggleBackground: '#505050',
    toggleHandle: '#FFFFFF',
  },
};

export type ThemeColors = typeof colors.light;